export default __webpack_public_path__ + "static/media/fairport-logo.4f0544cb.png";